import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { InfraService } from './infra.service';
import { InfraEndPointModel } from '../models/infraEndPoint.model';

@Injectable({
  providedIn: 'root'
})
export class AllwebjobstatusService {
  private configCoreAllwebjobstatusUrl: string;
  private infraDetails: InfraEndPointModel;

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe((data: InfraEndPointModel) => {
      this.configCoreAllwebjobstatusUrl = data.WebEndPoint2 + 'Allwebjobstatus';

    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

  }
  public getAllwebjobstatus() {
    return this.http.get(`${this.configCoreAllwebjobstatusUrl}/GetAllwebjobstatus`);
  }
}
